import "@theme/front/init.scss";
import "@mdi/font/css/materialdesignicons.min.css";
import "bootstrap/js/dist/collapse"
import "bootstrap/js/dist/dropdown"
import "bootstrap/js/dist/modal"

import {initScroll} from "./front/scroll";
import {onScroll} from "./front/navbar";

import "lightbox2/dist/css/lightbox.css";
import lightbox from "lightbox2/dist/js/lightbox";

import 'nette.ajax.js'
import Nette from "@/front/netteForms";
Nette.initOnLoad();
window.Nette = Nette;

document.addEventListener("DOMContentLoaded", () => {
	lightbox.option({
		wrapAround: true,
		showImageNumberLabel: false
	});

	if (window.innerWidth > 991) {
		const dropdowns = document.querySelectorAll(".dropdown");

		dropdowns.forEach(function (dropdown) {
			dropdown.addEventListener("mouseenter", function () {
				let menu = this.querySelector(".dropdown-menu");
				menu.classList.add("show");
			});

			dropdown.addEventListener("mouseleave", function () {
				let menu = this.querySelector(".dropdown-menu");
				menu.classList.remove("show");
			});
		});
	}

	initScroll();
	onScroll();

	window.addEventListener("scroll", function () {
		onScroll();
	});
});
